import cn from 'clsx';
import { EPartialCheckboxValue } from '../../enums/EPartialCheckboxValue';
import { memoWithDisplayName } from '../../helpers/memoWithDisplayName';
import styles from './PartialCheckbox.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var PartialCheckbox = memoWithDisplayName(function (props) {
  var value = props.value;

  var iconStyles = function () {
    switch (value) {
      case EPartialCheckboxValue.All:
        return styles['checkbox-all'];

      case EPartialCheckboxValue.Partial:
        return styles['checkbox-partial'];

      case EPartialCheckboxValue.None:
      default:
        return null;
    }
  }();

  return /*#__PURE__*/_jsx("div", {
    className: cn(styles['container'], value === EPartialCheckboxValue.None ? styles['theme-white'] : styles['theme-primary'], iconStyles)
  });
}, 'PartialCheckbox');